<template>
  <div>
    <div ref="chartContainer" style="width: 100%; height: 600px;margin-bottom: 50px" />
  </div>
</template>

<script>
import echarts from 'echarts'
import { getGrantPercentStat } from '@/api/statistics/user_remain'
import { dateStrTodate } from '@/utils'

export default {
  name: 'GrantPercentStat',
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: () => '发放占比'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          // type: 'scroll'
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        toolbox: {
          show: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            var tooltipContent = ''
            params.forEach(function(item) {
              if (item.value > 0) {
                tooltipContent += item.seriesName + ' : ' + item.value + '<br/>'
              }
            })
            return tooltipContent
          }
        },
        series: [
          {
            name: '占比',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    getTables(typ) {
      this.initChart()
      const queryParams = {}
      for (const i in this.params) {
        queryParams[i] = this.params[i]
      }
      queryParams.type = typ
      getGrantPercentStat(queryParams).then(res => {
        if (res.data.data.length > 0) {
          const d = []
          const date = []
          res.data.data.forEach(item => {
            d.push(item.rate)
            date.push(dateStrTodate(item.date))
          })

          this.option.series[0].data = d
          this.option.xAxis.data = date
        }
        this.chart.setOption(this.option, true)
      })
    }
  }
}
</script>

<style scoped>

</style>
